<template>
  <v-container id="extended-tables" fluid tag="section">
    <base-v-component heading="" link="componetns/simple-tables" />

    <base-material-card
      color="success"
      icon="mdi-clipboard-text"
      inline
      title="Registros pagos Bot"
      class="px-5 py-3 mb-5"
    >
      <v-row>
        <v-col cols="12" md="12" class="mt-10">
          <v-data-table
            :headers="headers"
            :items="pagosAgrupados"
            item-key="id"
            class="elevation-1"
            :search="search"
            :loading="loadingTable"
            loading-text="Cargando... Por favor esperar"
            show-expand
            :expanded.sync="expanded"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>Registros Pagos</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>

                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Buscar"
                  single-line
                  hide-details
                />

                <v-spacer></v-spacer>

                <!-- Switch Active -->
                <v-switch
                  v-model="active"
                  label="Por procesar"
                  class="mr-4"
                  @change="listar"
                />

                <v-btn color="primary" outlined class="mr-2" :loading="loadingTable" @click="listar">
                  Recargar
                </v-btn>

             

                <v-dialog v-model="dialogDelete" max-width="500px">
                  <v-card>
                    <v-card-title class="text-h5">
                      Esta seguro de eliminar datos?
                    </v-card-title>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                      <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>

            <!-- Imagen miniatura -->
            <template v-slot:item.link="{ item }">
              <v-img
                :src="item.link"
                max-width="80"
                max-height="80"
                contain
                class="grey lighten-4"
                style="cursor:pointer"
                @click="openImage(item.link)"
              />
            </template>

            <!-- Fecha -->
            <template v-slot:item.transferDate="{ item }">
              {{ formatDate(item.transferDate) }}
            </template>

            <!-- Total -->
            <template v-slot:item.totalAmount="{ item }">
              {{ money(item.totalAmount) }}
            </template>

            <!-- Total aplicado (sum de detalles) -->
            <template v-slot:item.totalApplied="{ item }">
              {{ money(sumAmounts(item.details)) }}
            </template>

            <!-- Chip validación (aplicado vs total) -->
            <template v-slot:item.match="{ item }">
              <v-chip
                small
                :color="isMatch(item) ? 'green' : 'red'"
                dark
              >
                {{ isMatch(item) ? 'OK' : 'Dif.' }}
              </v-chip>
            </template>

            <!-- Fila expandible: detalle -->
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length">
                <v-card outlined class="ma-2">
                  <v-card-title class="py-2">
                    Detalle de deudas asociadas ({{ item.details.length }})
                    <v-spacer />
                    <b>Total aplicado:</b>&nbsp;{{ money(sumAmounts(item.details)) }}
                  </v-card-title>

                  <v-card-text>
                    <v-data-table
                      dense
                      hide-default-footer
                      :headers="detailHeaders"
                      :items="item.details"
                    >
                      <template v-slot:item.amount="{ item: d }">
                        {{ money(d.amount) }}
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </td>
            </template>

            <!-- Acciones -->
            <template v-slot:item.actions="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on" large @click="openImage(item.link)">
                    <v-icon dense color="secondary">mdi-image</v-icon>
                  </v-btn>
                </template>
                <span>Ver imagen</span>
              </v-tooltip>
            </template>

            <template v-slot:no-data>
              <v-btn color="primary" @click="initialize">Recargar</v-btn>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </base-material-card>

    <!-- Dialog imagen grande -->
    <v-dialog v-model="dialogImage" max-width="900">
      <v-card>
        <v-toolbar dense color="primary" dark>
          <v-btn icon @click="dialogImage = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Comprobante</v-toolbar-title>
          <v-spacer />
        </v-toolbar>

        <v-card-text class="pa-4">
          <v-img
            :src="selectedImage"
            contain
            max-height="700"
            class="grey lighten-4"
          />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" :timeout="timeout">
      {{ text }}
      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  name: "DashboardExtendedTables",

  data: () => ({
    dialog: false,
    dialogDelete: false,

    // ✅ headers para 1 fila por imagen (agrupado)
    headers: [
      { text: "Imagen", value: "link", sortable: false },
      { text: "Urbanización", value: "community" },
      { text: "Edificiio", value: "building" },
      { text: "Número", value: "unitNumber" },
      { text: "Piso", value: "floor" },
      { text: "Propietario", value: "owner" },
      { text: "Banco", value: "bank" },
      { text: "No Transferencia", value: "documentNo" },
      { text: "Valor Transferencia", value: "totalAmount" },
      { text: "Valores Aplicados", value: "totalApplied", sortable: false },
      //{ text: "Match", value: "match", sortable: false },
      { text: "Fecha Transferencia", value: "transferDate" },
      { text: "Acciones", value: "actions", sortable: false }
    ],

    // ✅ headers detalle expandible
    detailHeaders: [
      //{ text: "Account receivable", value: "account_receivable_uq" },
      { text: "Documento", value: "number" },
      { text: "Monto", value: "amount", align: "end" }
    ],

    // ✅ data raw del endpoint
    rawItems: [],

    // expand
    expanded: [],

    // filtros
    active: false,

    editedIndex: -1,
    search: "",
    loadingTable: true,

    // imagen dialog
    dialogImage: false,
    selectedImage: "",

    // snackbar
    snackbar: false,
    text: "",
    timeout: 6000,

    // form existente
    validForm: false,
    requiredRule: [(v) => !!v || "Este campo es obligatorio"],
    Name: "",
    Address: "",
    City: "",
    State: "",
    PostalCode: "",
    selectedId: "",
    id: ""
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nueva urbanización" : "Editar urbanización";
    },

    // ✅ Agrupar por id (id = único por imagen)
    pagosAgrupados() {
      const map = new Map();

      (this.rawItems || []).forEach((x) => {
        const key = x.id;

        if (!map.has(key)) {
          map.set(key, {
            id: x.id,
            link: x.link,
            building: x.building,
            community: x.community,
            floor: x.floor,
            unitNumber: x.unitNumber,
            bank: (x.bank || "").trim(),
            documentNo: x.documentNo,
            totalAmount: x.totalAmount,
            transferDate: x.transferDate,
            owner: x.owner,
            paymentMethod: x.paymentMethod,
            details: []
          });
        }

        map.get(key).details.push({
          account_receivable_uq: x.account_receivable_uq,
          number: x.number,
          amount: x.amount
        });
      });

      return Array.from(map.values()).sort(
        (a, b) => new Date(b.transferDate) - new Date(a.transferDate)
      );
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    }
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      this.listar();
    },

    listar() {
      const me = this;
      me.loadingTable = true;

      const header = { Authorization: "Bearer " + this.$store.state.token };
      const configuracion = { headers: header };

      axios
        .get(`api/Bots/PendingPaymentsProcess/${me.active}`, configuracion)
        .then(function (response) {
          me.rawItems = response.data || [];
          me.loadingTable = false;
        })
        .catch((err) => {
          me.loadingTable = false;
          if (err.response && err.response.status === 401) {
            me.$store.dispatch("salir");
          } else {
            me.snackbar = true;
            me.text = err.message || "Error consultando el endpoint";
          }
        });
    },

    // ========= Helpers UI =========
    openImage(url) {
      this.selectedImage = url;
      this.dialogImage = true;
      console.log("Open image:", url);
    },

    formatDate(iso) {
      if (!iso) return "";
      return new Date(iso).toLocaleDateString("es-EC", {
        day: "2-digit",
        month: "short",
        year: "numeric"
      });
    },

    money(v) {
      return Number(v || 0).toLocaleString("es-EC", {
        style: "currency",
        currency: "USD"
      });
    },

    sumAmounts(details) {
      return (details || []).reduce((acc, x) => acc + Number(x.amount || 0), 0);
    },

    isMatch(group) {
      const total = Number(group.totalAmount || 0);
      const applied = Number(this.sumAmounts(group.details) || 0);
      // tolerancia por decimales
      return Math.abs(total - applied) < 0.01;
    },

    // ========= Métodos existentes (los dejo) =========
    guardar() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      if (this.$refs.form.validate()) {
        if (this.editedIndex > -1) {
          axios
            .post(
              "api/Communities/UpdateCommunity",
              {
                id: me.id,
                name: me.Name,
                address: me.Address,
                city: me.City,
                state: me.State,
                postalCode: me.PostalCode
              },
              configuracion
            )
            .then(function () {
              me.listar();
              me.$refs.form.reset();
            })
            .catch((err) => {
              if (err.response && err.response.status === 401) {
                me.$store.dispatch("salir");
              }
            });
        } else {
          axios
            .post(
              "api/Communities/InsertCommunity",
              {
                name: me.Name,
                address: me.Address,
                city: me.City,
                state: me.State,
                postalCode: me.PostalCode
              },
              configuracion
            )
            .then(function () {
              me.listar();
              me.$refs.form.reset();
            })
            .catch((err) => {
              if (err.response && err.response.status === 400) {
                me.snackbar = true;
                me.text = err.response.data.errors;
              }
              if (err.response && err.response.status === 401) {
                me.$store.dispatch("salir");
              }
            });
        }
        this.close();
      }
    },

    editar(item) {
      let me = this;
      me.id = item.id;
      me.Name = item.name;
      me.Address = item.address;
      me.City = item.city;
      me.State = item.state;
      me.PostalCode = item.postalCode;
      me.editedIndex = 1;
      this.dialog = true;
    },

    deleteItem(item) {
      let me = this;
      me.selectedId = item.id;
      me.dialogDelete = true;
    },

    deleteItemConfirm() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get("api/Communities/Delete/" + me.selectedId, configuracion)
        .then(function (response) {
          me.dialogDelete = false;
          if (response.data && response.data[0] && response.data[0]["error"]) {
            me.snackbar = true;
            me.text = response.data[0]["messagge"];
          }
          me.listar();
        })
        .catch((err) => {
          if (err.response && err.response.status === 401) {
            me.$store.dispatch("salir");
          }
        });
    },

    close() {
      this.dialog = false;
      this.editedIndex = -1;
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedIndex = -1;
      });
    }
  }
};
</script>